// LearnJS resources include video, pdf and sheets
import { exercises } from '@/store/exercises.js'

export const resources = [
  {
    id: 7,
    name: "1. Introduction to JavaScript",
    description:
      "About the JavaScript language and the environment to develop with it.",
    type: "pdf",
    url: "static/pdfs/r1.pdf",
    milestones: [
      { index: 1, label: "Start" },
      { index: 3, label: "Introdution to JavaScript" },
      { index: 6, label: "Specification and Manuals" },
      { index: 11, label: "Code Editors" },
      { index: 14, label: "Developer Console" },
      { index: 15, label: "End" },
    ],
  },
  {
    id: 8,
    name: "2. The Dev Environment",
    type: "pdf",
    url: "static/pdfs/r2.pdf",
    milestones: [
      { index: 1, label: "Start" },
      { index: 3, label: "Visual Studio Code" },
      { index: 10, label: "Visual Studio Code (themes)" },
      { index: 15, label: "Visual Studio Code (icons)" },
      { index: 16, label: "Visual Studio Code (extensions)" },
      { index: 35, label: "Git" },
      { index: 37, label: "GitHub" },
      { index: 38, label: "Integration VSC<->GitHub" },
      { index: 49, label: "End" },
    ],
  },
  {
    id: 9,
    name: "3. My First Application",
    type: "pdf",
    url: "static/pdfs/r3.pdf",
    milestones: [
      { index: 1, label: "Start" },
      { index: 3, label: "The script tag" },
      { index: 8, label: "Comments" },
      { index: 15, label: "Logging" },
      { index: 16, label: "Interaction" },
      { index: 21, label: "Hello World!" },
      { index: 22, label: "End" },
    ],
  },
  {
    id: 10,
    name: "1. Variables",
    type: "pdf",
    url: "static/pdfs/r4.pdf",
    milestones: [
      { index: 1, label: "Start" },
      { index: 3, label: "Declaration and Assignment" },
      { index: 8, label: "Constants" },
      { index: 12, label: "Naming" },
      { index: 17, label: "Scope" },
      { index: 22, label: "End" },
    ],
  },
  {
    id: 11,
    name: "2. Work on Variables",
    description:
      "This exercise sheet consist in several exercises whose main goal is to understand the use of variables.",
    type: "sheet",
    exercises: [16, 29, 18, 28, 17, 19],
  },
  {
    id: 12,
    name: "3. Data Types",
    type: "pdf",
    url: "static/pdfs/r5.pdf",
    milestones: [
      { index: 1, label: "Start" },
      { index: 6, label: "Number" },
      { index: 9, label: "BigInt" },
      { index: 11, label: "String" },
      { index: 14, label: "Boolean" },
      { index: 16, label: "Null and Undefined" },
      { index: 19, label: "Object and Symbol" },
      { index: 23, label: "Convert to String" },
      { index: 24, label: "Convert to Number" },
      { index: 27, label: "Convert to Boolean" },
      { index: 27, label: "End" },
    ],
  },
  {
    id: 13,
    name: "4. Work on Data Types",
    description:
      "This exercise sheet consist in several exercises whose main goal is to understand the use of data types and conversion between types.",
    type: "sheet",
    exercises: [20, 22, 23, 24],
  },
  {
    id: 14,
    name: "5. Operators",
    type: "pdf",
    url: "static/pdfs/r6.pdf",
    milestones: [
      { index: 1, label: "Start" },
      { index: 5, label: "Operator precedence" },
      { index: 6, label: "Arithmetic" },
      { index: 8, label: "Concatenation" },
      { index: 10, label: "Assignment" },
      { index: 12, label: "Rest and Exponentiation" },
      { index: 14, label: "Increment/Decrement" },
      { index: 18, label: "Comparison" },
      { index: 23, label: "Logic" },
      { index: 30, label: "End" },
    ],
  },
  {
    id: 15,
    name: "6. Work on Operators",
    description:
      "This exercise sheet consist in several exercises whose main goal is to understand the use of variables and operators.",
    type: "sheet",
    exercises: [21, 25, 26, 27],
  },
  {
    id: 40,
    name: "6. Conditionals",
    type: "pdf",
    url: "static/pdfs/r7.pdf",
    milestones: [
      { index: 1, label: "Start" },
      { index: 3, label: "IF statement" },
      { index: 7, label: "ELSE statement" },
      { index: 9, label: "IF...ELSE statement" },
      { index: 11, label: "? Ternary operator" },
      { index: 14, label: "SWITCH statement" },
      { index: 16, label: "End" },
    ],
  },
  {
    id: 41,
    name: "7. Work on Conditionals",
    description:
      "This exercise sheet consist in several exercises whose main goal is to understand the use of conditionals.",
    type: "sheet",
    exercises: [42, 43, 44, 45, 46, 47],
  },
  {
    id: 48,
    name: "8. Loops",
    type: "pdf",
    url: "static/pdfs/r8.pdf",
    milestones: [
      { index: 1, label: "Start" },
      { index: 3, label: "WHILE statement" },
      { index: 5, label: "DO...WHILE statement" },
      { index: 8, label: "FOR statement" },
      { index: 13, label: "End" },
    ],
  },
  {
    id: 49,
    name: "9. Work on Loops",
    description:
      "This exercise sheet consist in several exercises whose main goal is to understand the use of loops.",
    type: "sheet",
    exercises: [50, 51, 52, 53, 54],
  },
  {
    id: 55,
    name: "10. Functions",
    type: "pdf",
    url: "static/pdfs/r9.pdf",
    milestones: [
      { index: 1, label: "Start" },
      { index: 4, label: "Function declaration" },
      { index: 9, label: "Function naming" },
      { index: 11, label: "Local and global variables" },
      { index: 17, label: "Parameters" },
      { index: 25, label: "Function return" },
      { index: 29, label: "Function expressions" },
      { index: 35, label: "Arrow functions" },
      { index: 42, label: "End" },
    ],
  },
  {
    id: 56,
    name: "11. Work on Functions",
    description:
      "This exercise sheet consist in several exercises whose main goal is to understand the use of functions.",
    type: "sheet",
    exercises: [57, 58, 59, 60, 61, 62, 63, 64, 65, 66],
  },
  {
    id: 67,
    name: "12. Debugging",
    type: "pdf",
    url: "static/pdfs/r10.pdf",
    milestones: [
      { index: 1, label: "Start" },
      { index: 6, label: "Debugging in Chrome" },
      { index: 28, label: "Debugging in Visual Studio Code" },
      { index: 35, label: "End" },
    ],
  },
  {
    id: 68,
    name: "13. Introduction to DOM",
    type: "pdf",
    url: "static/pdfs/r11.pdf",
    milestones: [
      { index: 1, label: "Start" },
      { index: 4, label: "Document Object Model" },
      { index: 7, label: "DOM tree" },
      { index: 10, label: "Search" },
      { index: 17, label: "Edit" },
      { index: 22, label: "Navigation" },
      { index: 31, label: "Node management" },
      { index: 37, label: "Browser Object Model" },
      { index: 44, label: "End" },
    ],
  },
  {
    id: 69,
    name: "14. Work on DOM",
    description:
      "This exercise sheet consist in several exercises whose main goal is to understand the use of DOM.",
    type: "sheet",
    exercises: [70, 71, 72, 73, 74, 75, 76],
  },
  {
    id: 77,
    name: "14. Events",
    type: "pdf",
    url: "static/pdfs/r12.pdf",
    milestones: [
      { index: 1, label: "Start" },
      { index: 4, label: "Introduction to Events" },
      { index: 8, label: "Method addEventListener" },
      { index: 14, label: "Type of Events" },
      { index: 20, label: "Forms" },
      { index: 31, label: "End" },
    ],
  },
  {
    id: 78,
    name: "15. Work on Events",
    description:
      "This exercise sheet consist in several exercises whose main goal is to understand the use of Events.",
    type: "sheet",
    exercises: [79],
  },
  ...exercises
];
